import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { StaticQuery, graphql } from 'gatsby';
import { Facebook } from './Facebook';
import { Twitter } from './Twitter';

// Complete tutorial: https://www.gatsbyjs.org/docs/add-seo-component/

export default class SEO extends Component {
  render() {
    const { title, desc, banner, post, canonical, pageURL, featureImageUrl, isPost, yoast, acf = {}, wordpressId } = this.props;

    const shouldRenderServiceSchemas = acf.is_a_service;
    const shouldRenderPostSchema = isPost;
    // Output if Thank You Page
    const shouldRenderOpenAiLeadPixel = parseInt(wordpressId, 10) === 3183;
    const openAiLeadPixelScript = `!function(w,d,s,u){if(w.oaiq)return;var q=function(){q.q.push(arguments)};q.q=[];w.oaiq=q;var j=d.createElement(s);j.async=1;j.src=u;var f=d.getElementsByTagName(s)[0];f.parentNode.insertBefore(j,f)}(window,document,"script","https://bzrcdn.openai.com/sdk/oaiq.min.js");oaiq("init",{pixelId:"FkfJTGiZFjCqTDd6D8uPZs",debug:true});oaiq("measure","lead_created",{type:"customer_action"});oaiq("measure","registration_completed",{type:"customer_action",amount:0,currency:"AUD"});`

    return (
      <StaticQuery
        query={graphql`
          query {
            wordpressWpSettings {
              siteUrl
              wordpressUrl
              defaultTitle: title
              defaultDescription: description
              defaultBanner: banner
              siteLanguage
              twitter
              shortName
            }
          }
        `}
        render={({
          wordpressWpSettings: {
            defaultTitle,
            siteUrl,
            defaultDescription,
            defaultBanner,
            siteLanguage,
            twitter,
            shortName,
          }
        }) => {
          const seo = {
            title: title || defaultTitle,
            description: desc || defaultDescription,
            image: banner || defaultBanner,
            url: `${siteUrl}`,
            canonical: canonical
          };

          let schemaAreaServed = [
            {
              "@context": "https://schema.org",
              "@type": "Organization",
              "name": "Revell Landscaping",
              'telephone': '(08) 9379 9686',
              'url': siteUrl,
              'image': 'https://revell.com.au/static/header-logo-9914c5c22399241c04f5f61a2a9d3dc1.svg',
              "address": {
                '@type': 'PostalAddress',
                'streetAddress': 'Unit 6/26 River Road',
                'addressLocality': 'Bayswater',
                'addressRegion': 'WA',
                'postalCode': '6053',
                'addressCountry': 'AU'
              },
              "areaServed": {
                "@type": "GeoCircle",
                "geoMidpoint": {
                  "@type": "GeoCoordinates",
                  "latitude": -31.922554433569317,
                  "longitude": 115.92940356718937
                },
                "geoRadius": 5000
              },
              // "aggregateRating": {
              //     "@type": "AggregateRating",
              //     "bestRating": 100,
              //     "worstRating": 0,
              //     "ratingValue": 88,
              //     "reviewCount": 122
              // }
            }
          ];

          let serviceSchema = [
            {
              "@context": "https://schema.org/",
              "@type": "Service",
              "serviceType": title,
              "provider": {
                "@type": "LocalBusiness",
                "name": "Revell Landscaping",
                "address": {
                  "@type": "PostalAddress",
                  "streetAddress": "Unit 6/26 River Rd",
                  "addressLocality": "Bayswater",
                  "addressRegion": "WA",
                  "postalCode": "6053",
                  "addressCountry": "AU"
                },
              },
              "name": title,
              "url": "https://revell.com.au/",
              "description": desc,
            },
          ]


          let GoogleReviewSchema = {
            "@context": "http://schema.org/",
            "@type": "Product",
            "name": title,
            "aggregateRating": {
              "@type": "AggregateRating",
              "ratingValue": "4.5",
              "reviewCount": "123"
            },
            "review": [
              {
                "@type": "Review",
                "author": {
                  "@type": "Person",
                  "name": "Loretta"
                },
                "datePublished": "2024-05-30",
                "text": "Revell did man amazing job with our backyard renovation, from design through to the end product, which we are delighted with. We could not have asked for a better team - from the crew onsite to those in the Office. They were professional, respectful and flexible. We have worked with a lot of good tradespeople over the last few years with our home renovation, but Revell were a standout.",
                "reviewRating": {
                  "@type": "Rating",
                  "ratingValue": "5"
                }
              },
              {
                "@type": "Review",
                "author": {
                  "@type": "Person",
                  "name": "Michael McBride"
                },
                "datePublished": "2025-04-29",
                "text": "Great team to deal with and end product is even better! Our experience with Revell right from the start was top quality. The design met our brief, the on site team were the most professional trades through our whole build process - our only wish is that Revell built houses, would have been great to have worked with them for everything with their professionalism and qualify workmanship.",
                "reviewRating": {
                  "@type": "Rating",
                  "ratingValue": "5"
                }
              }
            ]
          }

          let schemaOrgJSONLD = [
            {
              '@context': 'https://schema.org',
              '@graph': [
                {
                  '@type': 'Organization',
                  'name': 'Revell Landscaping',
                  'alternateName': 'Revell',
                  'url': siteUrl,
                  'logo': 'https://revell.com.au/static/header-logo-9914c5c22399241c04f5f61a2a9d3dc1.svg',
                  'sameAs': [
                    'https://www.facebook.com/revelllandscaping/',
                    'https://www.pinterest.com.au/revelllandscape/',
                    'https://www.instagram.com/revelllandscaping/',
                    'https://www.houzz.com.au/professionals/landscape-architects-and-designers/revell-landscaping-pfvwau-pf~404193327?'
                  ]
                },
                {
                  '@type': 'WebSite',
                  'name': defaultTitle,
                  'url': siteUrl
                },
                {
                  "@context": "https://schema.org",
                  "@graph": [
                    {
                      "@type": "LocalBusiness",
                      "name": "Revell Landscaping",
                      "image": "https://revell.com.au/static/header-logo-9914c5c22399241c04f5f61a2a9d3dc1.svg",
                      "url": "https://revell.com.au/",
                      "telephone": "+61893799686",
                      "priceRange": "$$$",
                      "address": {
                        "@type": "PostalAddress",
                        "streetAddress": "Unit 6/26 River Rd",
                        "addressLocality": "Bayswater",
                        "addressRegion": "WA",
                        "postalCode": "6053",
                        "addressCountry": "AU"
                      },
                      "geo": {
                        "@type": "GeoCoordinates",
                        "latitude": -31.91897,
                        "longitude": 115.91525
                      },
                      "openingHoursSpecification": [
                        {
                          "@type": "OpeningHoursSpecification",
                          "dayOfWeek": [
                            "Monday",
                            "Tuesday",
                            "Wednesday",
                            "Thursday",
                            "Friday"
                          ],
                          "opens": "07:00",
                          "closes": "16:00"
                        }
                      ],
                      "sameAs": [
                        "https://www.facebook.com/revellandscaping/",
                        "https://www.instagram.com/revellandscaping/"
                      ],
                      "areaServed": [
                        {
                          "@type": "Place",
                          "name": "Perth Metropolitan Area"
                        }
                      ]
                    },
                    {
                      "@type": "Review",
                      "itemReviewed": {
                        "@type": "LocalBusiness",
                        "name": "Revell Landscaping",
                        "image": "https://revell.com.au/static/header-logo-9914c5c22399241c04f5f61a2a9d3dc1.svg",
                        "url": "https://revell.com.au/",
                        "address": {
                          "@type": "PostalAddress",
                          "streetAddress": "Unit 6/26 River Rd",
                          "addressLocality": "Bayswater",
                          "addressRegion": "WA",
                          "postalCode": "6053",
                          "addressCountry": "AU"
                        },
                      },
                      "reviewRating": {
                        "@type": "Rating",
                        "ratingValue": "5",
                        "bestRating": "5"
                      },
                      "author": {
                        "@type": "Person",
                        "name": "Justine Barsley"
                      },
                      "publisher": {
                        "@type": "Organization",
                        "name": "Revell Landscaping"
                      },
                      "reviewBody": "Very happy with our landscaping job. Revell were professional and meet all the timeframes they promised. They listened to our needs and provided plants that would work in the space and were flexible in installing our reticulation in a tricky spot. Unexpectedly we received a lovely hamper post job. Thank you.",
                      "url": "https://revell.com.au/about-us/testimonials/"
                    },
                    {
                      "@type": "ImageObject",
                      "contentUrl": "https://revell.com.au/static/header-logo-9914c5c22399241c04f5f61a2a9d3dc1.svg",
                      "name": "Revell Landscaping Logo",
                      "description": "The official logo for Revell Landscaping.",
                      "license": "https://revell.com.au/terms-of-use/",
                      "acquireLicensePage": "https://revell.com.au/contact/"
                    },
                    {
                      "@type": "VideoObject",
                      "name": "Revell Landscaping Showcase",
                      "description": "A showcase of our recent landscaping projects in and around Perth.",
                      "thumbnailUrl": "https://i.ytimg.com/vi/p53E8x4rztE/hq720.jpg?sqp=-oaymwFBCNAFEJQDSFryq4qpAzMIARUAAIhCGAHYAQHiAQoIGBACGAY4AUAB8AEB-AHUBoAC4AOKAgwIABABGEYgZSgyMA8=&rs=AOn4CLCEWOhDOEo6ikJEc-f2rWV8emGyNA",
                      "uploadDate": "2025-01-01T08:00:00+08:00",
                      "duration": "PT2M30S",
                      "contentUrl": "https://www.youtube.com/watch?v=p53E8x4rztE",
                      "embedUrl": "https://www.youtube.com/@revelllandscaping9013",
                      "publisher": {
                        "@type": "Organization",
                        "name": "Revell Landscaping",
                        "logo": {
                          "@type": "ImageObject",
                          "url": "https://revell.com.au/static/header-logo-9914c5c22399241c04f5f61a2a9d3dc1.svg"
                        }
                      }
                    }
                  ]
                }
              ]
            }
          ];
          let postSchema = {};
          if (post) {
            postSchema = [{
              "@context": "https://schema.org",
              "@type": "Article",
              "@id": `${siteUrl}/${post.slug}/#article`,
              "isPartOf": {
                "@id": `${siteUrl}/${post.slug}/`
              },
              "author": {
                "name": 'Revell Landscaping',
                "@id": `${siteUrl}/#/schema/person/revell-landscaping`
              },
              "headline": title,
              "datePublished": post.date,
              "dateModified": post.date,
              "mainEntityOfPage": {
                "@id": `${siteUrl}/${post.slug}/`
              },
              "wordCount": post.content ? post.content.length : 0,
              "publisher": {
                "@id": `${siteUrl}/#organization`
              },
              "image": {
                "@id": `${siteUrl}/${post.slug}/#primaryimage`
              },
              "thumbnailUrl": featureImageUrl,
              "articleSection": [
                "Landscaping"
              ],
              "inLanguage": "en-AU"
            }]

            schemaOrgJSONLD = [
              {
                '@context': 'http://schema.org',
                '@type': 'BlogPosting',
                '@id': seo.url,
                url: seo.url,
                name: title,
                headline: title,
                image: {
                  '@type': 'ImageObject',
                  url: seo.image,
                },
                description: seo.description,
                datePublished: post.date,
                dateModified: post.date,
                author: {
                  '@type': 'Person',
                  name: "Revell Landscaping",
                },
                publisher: {
                  '@type': 'Organization',
                  name: 'Revell Landscaping',
                  logo: {
                    '@type': 'ImageObject',
                    url: `${siteUrl}/logos/logo-1200x630.jpg`,
                  },
                },
                isPartOf: siteUrl,
                mainEntityOfPage: {
                  '@type': 'WebSite',
                  '@id': siteUrl,
                },
              },
            ];
          }

          return (
            <>
              <Helmet title={seo.title}>
                <link rel="canonical" href={seo.canonical} data-src="app" />
                <html lang={siteLanguage} />
                <meta name="description" content={seo.description} />
                <meta name="image" content={seo.image} />
                <meta name="apple-mobile-web-app-title" content={shortName} />
                <meta name="application-name" content={shortName} />
                <script type="application/ld+json">{JSON.stringify(schemaOrgJSONLD)}</script>
                <script type="application/ld+json">{JSON.stringify(schemaAreaServed)}</script>                

                {post && (
                  <script type="application/ld+json">{JSON.stringify(postSchema)}</script>
                )}

                {shouldRenderServiceSchemas && (
                  <script type="application/ld+json">{JSON.stringify(serviceSchema)}</script>
                )}
                {shouldRenderServiceSchemas && (
                  <script type="application/ld+json">{JSON.stringify(GoogleReviewSchema)}</script>
                )}
                {shouldRenderOpenAiLeadPixel && (
                  <script type="text/javascript">{openAiLeadPixelScript}</script>
                )}
              </Helmet>
              <Facebook
                desc={seo.description}
                image={seo.image}
                title={seo.title}
                type={post ? 'article' : null}
                url={seo.url}
              />
              <Twitter title={seo.title} image={seo.image} desc={seo.description} username={twitter} />
            </>
          );
        }}
      />
    );
  }
}
